import React from 'react'
import { Field } from 'redux-form'
import i18n from '../../translations/i18n';
import renderSelect from '../fields/renderSelect';

let AddOns = props => {
	let lng = props.lng;
	return (
		<div>
		<div className="form-section">
			<div className="subtitle title title-border title-border text-left">
				<h6>{i18n.t('addons.title', {lng})}</h6>
			</div>
			<div>
				<div className="row">
					<div className="col-12 form-input">
						<label className='simple-checkbox'>
							{i18n.t('addons.desktop_publishing', {lng})}
							<Field
								name="desktopPublishing"
								component="input"
								type="checkbox"
								label={i18n.t('addons.desktop_publishing', {lng})}
								value="desktopPublishing"
							/>
							<span className="checkboxmark"></span>
						</label>
					</div>
				</div>
				{props.translationLevel==="premium"&&
					<div className="row">
						<div className="col-12 col-md-6 form-input">
							<label className='simple-checkbox'>
								{i18n.t('addons.certification', {lng})}
								<Field
									name="certification"
									component="input"
									type="checkbox"
									label={i18n.t('addons.certification', {lng})}
									value="certification"
								/>
								<span className="checkboxmark"></span>
							</label>
						</div>
						{props.certification&&
							<div className="col-12 col-md-6 form-input">
								<Field
									name="requestOrigin"
									component={renderSelect}
									label={i18n.t('official.request_origin', {lng})}
									options={props.requestOrigin}
									placeholder={i18n.t('app.please_select', {lng})}
								/>
							</div>}
						<div className="col-12 form-input">
							<label className='simple-checkbox'>
								{i18n.t('addons.transcreation', {lng})}
								<Field
									name="transcreation"
									component="input"
									type="checkbox"
									label={i18n.t('addons.transcreation', {lng})}
									value="transcreation"
								/>
								<span className="checkboxmark"></span>
							</label>
						</div>
						{props.certification&&
							<div className="col-12 form-input">
								<label className='simple-checkbox'>
									{i18n.t('addons.legalization', {lng})}
									<Field
										name="legalization"
										component="input"
										type="checkbox"
										label={i18n.t('addons.legalization', {lng})}
										value="legalization"
									/>
									<span className="checkboxmark"></span>
								</label>
							</div>}
					</div>}
				</div>
		</div>
	</div>
	)
}


export default AddOns


// WEBPACK FOOTER //
// ./src/components/translation/addons.js